import React from "react"
import {Grid, Modal} from "semantic-ui-react"
import {FormattedMessage, useIntl} from "react-intl"


export const HowitworksFamilies = () => {
    const intl = useIntl()
    return (
        <>
            <Modal.Header>
                <h1><FormattedMessage id="howitworks.families.header" values={{
                    families: <span style={{ color: "var(--creator-fam-teal-active)"}}>
                        {(intl.formatMessage({id: "creator.tabs.families"})).toLowerCase()}:
                    </span>
                }}/></h1>
            </Modal.Header>

            <Modal.Content className="howitworks-families">
                {/* Inactive */}
                <p><FormattedMessage id="howitworks.families.about" values={{
                    inactive: <span style={{ color: "lightgray", fontWeight: "bold", fontSize: 17 }}>
                        [<FormattedMessage id="howitworks.families.inactive"/>]
                    </span>,
                    break: <br/>
                }}/></p>
                {/* Required fields */}
                <p style={{ marginTop: 0, marginBottom: 0, lineHeight: 1.5 }}><FormattedMessage id="howitworks.families.col1" values={{
                    id: <span style={{ color: "coral", fontWeight: "bold", fontSize: 17 }}>
                        <FormattedMessage id="creator.column.individual.id"/>
                    </span>,
                    spouses: <span style={{ color: "coral", fontWeight: "bold", fontSize: 17 }}>
                        <FormattedMessage id="howitworks.families.spouses"/>
                    </span>,
                    break: <br/>
                }}/></p>
                <Grid columns={1}>
                    <Grid.Row style={{ paddingTop: 0 }}>
                        <Grid.Column className="col1">
                            <img src={`/assets/howitworks/${intl.locale}/families/families2.png`} alt="families table"/>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>

                <p className="puzzle"><FormattedMessage id="howitworks.families.fundamental" values={{
                    link: <span style={{ fontWeight: "bold", fontSize: 17 }}>
                        <FormattedMessage id="howitworks.families.link"/>
                    </span>,
                    individual: <span style={{ color: "var(--creator-indi-yellow-active)", fontWeight: "bold", fontSize: 17 }}>
                        <FormattedMessage id="creator.constraints.entity.individual"/>
                    </span>,
                    family: <span style={{ color: "var(--creator-fam-teal-active)", fontWeight: "bold", fontSize: 17 }}>
                        <FormattedMessage id="creator.constraints.entity.family"/>
                    </span>,
                    break: <br/>
                }}/></p>
                {/* Disabled */}
                <p><FormattedMessage id="howitworks.families.disabled.remember" values={{
                    disabled: <span style={{ color: "lightgray", fontWeight: "bold", fontSize: 17 }}>
                        [<FormattedMessage id="howitworks.individuals.disabled"/>]
                    </span>
                }}/></p>

                {/* Puzzle */}
                <p style={{ marginTop: 30 }}><FormattedMessage id="howitworks.families.puzzle" values={{
                    spouses: <span style={{ fontWeight: "bold", fontSize: 17 }}>
                        <FormattedMessage id="howitworks.families.spouses"/>
                    </span>,
                    ancestors: <span style={{ fontWeight: "bold", fontSize: 17 }}>
                        <FormattedMessage id="howitworks.gedcom.col1.ancestors"/>
                    </span>,
                    descendants: <span style={{ fontWeight: "bold", fontSize: 17 }}>
                        <FormattedMessage id="howitworks.gedcom.col2.descendants"/>
                    </span>,
                    puzzle: "🧩"
                }}/></p>
            </Modal.Content>
        </>
    )
}